import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ServersService} from '../../services/servers.service';
import {ServerModel} from '../../models/server.model';

@Component({
  selector: 'lba-select-server',
  templateUrl: './select-server.component.html',
  styleUrls: ['./select-server.component.scss'],
})
export class SelectServerComponent implements OnInit, OnDestroy {

  searchStr: string = '';

  servers: ServerModel[];

  serverName: string = 'Select server';

  subscription: Subscription;

  isLoaded: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private serversService: ServersService,
  ) {
  }

  ngOnInit() {
    this.subscription = this.serversService.getServers()
      .subscribe((data: ServerModel[]) => {
        this.isLoaded = true;
          this.servers = data.filter(
            server => server.deploymentStatus > 0);
      },
        error => {
          console.log(error);
          window.alert('Error: ' + error.message + ', error status: ' + error.status);
        });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  closeModal() {
    this.activeModal.close();
  }

  selectServer(selectedObject: ServerModel) {
    this.activeModal.close(selectedObject);
  }

}

